/**
 * @license
 * Copyright (c) 2025 Handsoncode. All rights reserved.
 */
import { DenseStrategy } from "./DenseStrategy.mjs";
import { SparseStrategy } from "./SparseStrategy.mjs";
export class DenseSparseChooseBasedOnThreshold {
  constructor(threshold) {
    this.threshold = threshold;
  }
  call(fill) {
    if (fill > this.threshold) {
      return DenseStrategy;
    } else {
      return SparseStrategy;
    }
  }
}
export class AlwaysSparse {
  call() {
    return SparseStrategy;
  }
}
export class AlwaysDense {
  call() {
    return DenseStrategy;
  }
}